/**
 * File navigation.js
 * Animated navigation with exit + entry transitions
 */

/* ------------------------------
   GLOBAL STATE
------------------------------ */
document.documentElement.classList.add("is-hydrating");

window.mobileCheck = function() {
	let ua = navigator.userAgent || navigator.vendor || window.opera;

	// Original mobile regex (matches phones)
	let isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(ua);

	// Tablet regex (adds tablets)
	let isTablet = /(ipad|tablet|(android(?!.*mobile))|kindle|playbook|silk)/i.test(ua);

	return isMobile || isTablet;
};

( function() {
	const siteNavigation = document.getElementById( 'site-navigation' );

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const button = document.querySelector("button.menu-toggle");

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	button.addEventListener('click', function () {
		document.querySelector("body").classList.toggle('toggled');

		if (button.getAttribute('aria-expanded') === 'true') {
			button.setAttribute('aria-expanded', 'false');
		} else {
			button.setAttribute('aria-expanded', 'true');
		}
	});

	// Get all the link elements within the menu.
	const links = menu.getElementsByTagName( '.menu-item-has-children > a' );

	// Get all the link elements with children within the menu.
	const linksWithChildren = menu.querySelectorAll( '.menu-item-has-children > a, .page_item_has_children > a' );

	// Toggle focus each time a menu link is focused or blurred.
	for ( const link of links ) {
		link.addEventListener( 'focus', toggleFocus, true );
		link.addEventListener( 'blur', toggleFocus, true );
	}

	// Toggle focus each time a menu link with children receive a touch event.
	for ( const link of linksWithChildren ) {
		link.addEventListener( 'touchstart', toggleFocus, false );
	}



	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}
}() );

const header = document.querySelector('.site-header');
if (header) {
	const scrollThreshold = 50;
	window.addEventListener('scroll', () => {
		if (window.scrollY >= scrollThreshold) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});
	window.addEventListener('DOMContentLoaded', () => {
		if (window.scrollY >= scrollThreshold) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});
}

const footer = document.querySelector('.site-footer');
if (footer) {
	const footerMiddle = footer.querySelector('#footerMiddle');
	Array.from(footerMiddle.querySelectorAll('div.toggle')).forEach(toggle => {
		toggle.addEventListener('click', () => {
			toggle.classList.toggle('active');
		});
	});
}

/* Force Edge back refresh */
window.addEventListener('pageshow', function (event) {
	// If the page was restored from the back/forward cache
	if (event.persisted) {
		window.location.reload();
	}
});

/* ------------------------------
   Main navigation interactions
------------------------------ */
const initMainnavDropdowns = () => {
	const mainMenu = document.querySelector("#primary-menu");
	if (!mainMenu) return;

	const dropdowns = mainMenu.querySelectorAll(".menu-item-has-children");

	dropdowns.forEach((dropdown) => {
		const toggle = dropdown.querySelector(":scope > a");
		if (!toggle) return;

		toggle.addEventListener("click", (e) => {
			e.preventDefault();

			// play EXIT animation on entire menu
			mainMenu.classList.add("menu-exit");

			// navigate AFTER animation
			setTimeout(() => {
				window.location.href = toggle.href;
			}, 350);
		});
	});
};

/* ------------------------------
   Restore submenu based on current page
------------------------------ */
const openCurrentSubmenu = () => {
	const mainMenu = document.querySelector("#primary-menu");
	if (!mainMenu) return;

	const currentItem = mainMenu.querySelector(
		".current-menu-parent, .current-menu-ancestor"
	);

	if (!currentItem) return;

	const submenu = currentItem.querySelector(":scope > .sub-menu");
	const toggle = currentItem.querySelector(":scope > a");

	if (!submenu || !toggle) return;

	// hide siblings
	mainMenu.querySelectorAll(":scope > li").forEach((item) => {
		if (item !== currentItem) item.style.display = "none";
	});

	submenu.style.display = "block";
	requestAnimationFrame(() => {
		submenu.classList.add("submenu-opening");
	});
	toggle.style.display = "none";

	// inject back button
	if (!submenu.querySelector(".back-button")) {
		const backLi = document.createElement("li");
		backLi.className = "back-button";

		const lang = document.documentElement.lang;

		// Back button labels by language
		const backLabels = {
			'nl-NL': 'Terug',
			'en-US': 'Return',
			'de-DE': 'Zurück'
		};

		const backLabel = backLabels[lang] || backLabels['en-US'];

		const backLink = document.createElement("a");
		backLink.innerText
		backLink.textContent = backLabel;
		backLi.appendChild(backLink);
		submenu.prepend(backLi);

		backLink.addEventListener("click", (ev) => {
			ev.preventDefault();

			submenu.classList.remove("submenu-opening");
			submenu.classList.add("submenu-closing");

			const handleCloseEnd = (event) => {
				if (event.target !== submenu) return;

				submenu.removeEventListener("animationend", handleCloseEnd);


				const lang = document.documentElement.lang;
				if (lang === 'nl-NL') {
					window.location.href = "/nl";
				} else if (lang === 'de-DE') {
					window.location.href = "/de";
				} else {
					window.location.href = "/";
				}

				setTimeout(() => {
					submenu.style.display = "none";
					submenu.classList.remove("submenu-closing");
					toggle.style.display = "block";
					backLi.remove();

					mainMenu.querySelectorAll(":scope > li").forEach((item) => {
						item.style.display = "";
					});
				},1000);
			};

			submenu.addEventListener("animationend", handleCloseEnd);
		});
	}
};

/* ------------------------------
   Init
------------------------------ */
document.addEventListener("DOMContentLoaded", () => {
	initMainnavDropdowns();
	openCurrentSubmenu();

	requestAnimationFrame(() => {
		const mainMenu = document.querySelector("#primary-menu");
		if (mainMenu) mainMenu.classList.add("menu-ready");
		document.documentElement.classList.remove("is-hydrating");
	});
});


const initMobileMenuDropdowns = (scope = document) => {
	const topLevelMenus = document.querySelectorAll('#mobile-menu.menu > li');
	const menuAppend = document.querySelector('.menu-append');
	let timeout;

	topLevelMenus.forEach((menuItem, index) => {
		const submenuId = `submenu-${index}`;
		const subMenu = menuItem.querySelector('.sub-menu');

		if (subMenu) {
			const firstLevelSubMenu = subMenu.cloneNode(true);
			const parentUl = menuItem.parentNode;

			firstLevelSubMenu.classList.remove('sub-menu');
			firstLevelSubMenu.classList.add('first-level', 'sub-menu');
			firstLevelSubMenu.setAttribute('id', submenuId);

			menuItem.removeChild(subMenu);
			parentUl.appendChild(firstLevelSubMenu);

			const submenuInner = document.createElement('div');
			submenuInner.classList.add('submenu-inner');

			const submenuInnerInner = document.createElement('div');
			submenuInnerInner.classList.add('submenu-inner-inner');

			// --- Header wrapper ---
			const headerWrapper = document.createElement('div');
			headerWrapper.classList.add('submenu-header-wrapper');

			// Determine document language
			const lang = document.documentElement.lang;

			// Back button labels by language
			const backButtonLabels = {
				'nl-NL': 'Terug',
				'en-US': 'Back',
				'de-DE': 'Zurück'
			};

			// Fallback to Dutch if language is not explicitly handled
			const backLabel = backButtonLabels[lang] || backButtonLabels['nl-NL'];

			// Back button
			const backButton = document.createElement('a');
			backButton.classList.add('back-button');
			backButton.textContent = backLabel;
			backButton.addEventListener('click', () => {
				firstLevelSubMenu.classList.remove('submenu-visible');
			});
			headerWrapper.appendChild(backButton);


			submenuInnerInner.appendChild(headerWrapper);

			// --- Submenu items wrapper ---
			const itemsWrapper = document.createElement('div');
			itemsWrapper.classList.add('submenu-items-wrapper');
			Array.from(firstLevelSubMenu.children).forEach((node) => {
				itemsWrapper.appendChild(node);
			});
			submenuInnerInner.appendChild(itemsWrapper);

			firstLevelSubMenu.innerHTML = '';
			firstLevelSubMenu.appendChild(submenuInner);
			submenuInner.appendChild(submenuInnerInner);

			if (menuAppend) {
				submenuInner.appendChild(menuAppend.cloneNode(true));
			}

			// Handle second level submenu
			const secondLevelSubMenu = submenuInnerInner.querySelector('.sub-menu');
			if (secondLevelSubMenu) {
				secondLevelSubMenu.classList.remove('sub-menu');
				secondLevelSubMenu.classList.add('second-level', 'sub-menu');
			}
		}

		// Hover vs click behavior
		if (!window.mobileCheck()) {
			menuItem.addEventListener('mouseover', () => {
				clearTimeout(timeout);
				document.querySelectorAll('.first-level.sub-menu').forEach((submenu) => {
					submenu.classList.remove('submenu-visible');
					header.classList.remove('submenu-open');
				});
				const correspondingSubMenu = document.getElementById(submenuId);
				if (correspondingSubMenu) {
					correspondingSubMenu.classList.add('submenu-visible');
					header.classList.add('submenu-open');
				}
			});
			menuItem.addEventListener('mouseout', () => {
				timeout = setTimeout(() => {
					const correspondingSubMenu = document.getElementById(submenuId);
					if (correspondingSubMenu) {
						correspondingSubMenu.classList.remove('submenu-visible');
						header.classList.remove('submenu-open');
					}
				}, 100);
			});
		} else {
			menuItem.addEventListener('click', (e) => {
				if (menuItem.classList.contains('menu-item-has-children')) e.preventDefault();
				const correspondingSubMenu = document.getElementById(submenuId);
				if (correspondingSubMenu) {
					correspondingSubMenu.classList.toggle('submenu-visible');
					header.classList.toggle('submenu-open');
				}
			});
		}

		// Prevent submenu flicker
		const correspondingSubMenu = document.getElementById(submenuId);
		if (correspondingSubMenu) {
			correspondingSubMenu.addEventListener('mouseover', () => clearTimeout(timeout));
			correspondingSubMenu.addEventListener('mouseout', () => {
				timeout = setTimeout(() => {
					correspondingSubMenu.classList.remove('submenu-visible');
					header.classList.remove('submenu-open');
				}, 100);
			});
		}
	});
};

const keepActiveMobileSubmenuOpen = () => {
	const mobileMenu = document.querySelector("#mobile-menu > ul");
	if (!mobileMenu) return;

	const currentPath = window.location.pathname;
	const dropdowns = mobileMenu.querySelectorAll("li.page_item_has_children");

	dropdowns.forEach(dropdown => {
		const toggle = dropdown.querySelector(":scope > a");
		const dropdownMenu = dropdown.querySelector(":scope > .children");
		const submenuLinks = dropdownMenu?.querySelectorAll("a[href]");

		submenuLinks?.forEach(link => {
			const linkPath = new URL(link.href).pathname;

			if (linkPath === currentPath) {
				mobileMenu.querySelectorAll(":scope > li").forEach(item => {
					if (item !== dropdown) {
						item.style.display = "none";
						item.classList.remove("is-active");
					}
				});

				const lang = document.documentElement.lang;

				const backLabels = {
					'nl-NL': 'Terug',
					'en-US': 'Return',
					'de-DE': 'Zurück'
				};

				const backLabel = backLabels[lang] || backLabels['en-US'];

				dropdown.classList.add("is-active");
				dropdownMenu.style.display = "block";
				toggle.style.display = "none";

				if (!dropdownMenu.querySelector(".back-button")) {
					const backLi = document.createElement("li");
					backLi.className = "back-button";
					const backLink = document.createElement("a");
					backLink.href = "#";
					backLink.textContent = backLabel;
					backLi.appendChild(backLink);
					dropdownMenu.prepend(backLi);

					backLink.addEventListener("click", (ev) => {
						ev.preventDefault();
						dropdown.classList.remove("is-active");
						dropdownMenu.style.display = "none";
						toggle.style.display = "block";

						mobileMenu.querySelectorAll(":scope > li").forEach(item => {
							item.style.display = "";
						});
						backLi.remove();
					});
				}
			}
		});
	});
};

document.addEventListener("DOMContentLoaded", () => {
	initMobileMenuDropdowns();
	keepActiveMobileSubmenuOpen();
});